<template>
  <div class="jumbotron my-3">
    <h1 class="display-4 text-warning">{{ title }}</h1>
    <p class="text-info display-6">
      {{ body }}
    </p>
    <hr class="my-4" />
    <p class="text-light lead font-weight-bold">
      {{ footer }}
    </p>
    <p class="lead mt-4">
      <a
        class="btn btn-outline-info btn-lg font-weight-bold"
        href="#"
        role="button"
        @click="$router.push('/')"
        >Try Again</a
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "Jumbotron",
  props: {
    title: String,
    body: String,
    footer: String,
  },
};
</script>
